var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUtilities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#376F66",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 10.5v3a2 2 0 002 2h4a2 2 0 002-2v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5h10v3a5 5 0 11-10 0v-3zM5.5.5v3M11.5.5v3"
  }))));
}
export default SvgIconUtilities;